import styled from 'styled-components';

import { AnchorButton } from 'src/components/core/button';
import { EmbeddedAccountIcon } from 'src/assets/embedded-account-icon';
import { mediaSizes } from 'shared/styles';
import { KIOSK_PRO_MEDIA } from 'src/components/kiosk-pro/kiosk-pro-shared/kiosk-pro-shared.styles';

export const ConsumerInfoContainer = styled.div<{ $isUserLoggedIn: boolean }>`
  position: fixed;
  z-index: 99;
  bottom: 160px;
  left: 20px;
  right: 20px;
  border-radius: 24px;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 0px 12px 12px rgb(0 0 0 / 10%);
  max-width: 1000px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  text-align: center;
  font-size: clamp(16px, 1.5vw, 20px);
  font-weight: 700;

  @media (max-width: ${mediaSizes.tablet}px) {
    bottom: 112px;
  }

  @media (orientation: landscape) {
    right: auto;
    bottom: 0;
    border-radius: 24px 24px 0 0;
    flex-direction: ${({ $isUserLoggedIn }) => ($isUserLoggedIn ? 'column' : 'column-reverse')};
    align-items: flex-start;
    width: 100%;
    max-width: 360px;

    @media ${KIOSK_PRO_MEDIA.maxWidth} {
      max-width: 280px;
    }
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 30px 30px 0 40px;
  font-size: clamp(20px, 1.5vw, 24px);

  @media (orientation: portrait) {
    padding: 40px 30px;
  }
`;

export const ThemedEmbeddedAccountIcon = styled(EmbeddedAccountIcon)`
  color: ${({ theme }) => theme.customized.colors.buttonsLinks};
`;

export const InfoText = styled.div`
  margin-left: 20px;
  text-align: left;
  color: ${({ theme }) => theme.colors.grey[40]};
  line-height: 1.4;
`;

export const Points = styled.p`
  display: block;
  color: ${({ theme }) => theme.colors.black};
`;

export const ButtonContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 0 30px;

  @media (orientation: landscape) {
    flex-direction: column;
    width: 100%;
    padding: 24px;
  }

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth} {
    padding: 20px;
  }
`;

export const BaseButton = styled(AnchorButton)`
  width: 100%;
  padding: 24px;
  font-size: 24px;
  font-weight: 700;
  border: 4px solid ${({ theme }) => theme.customized.colors.buttonsLinks};

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth} {
    padding: 20px;
    font-size: 20px;
  }

  @media ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    font-size: 20px;
    padding: 20px;
  }
`;

export const EndSessionButton = styled(BaseButton)`
  width: 200px;
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.customized.colors.buttonsLinks};

  @media (orientation: landscape) {
    width: 100%;
  }
`;

export const Badge = styled.div`
  background-color: #26a27b;
  color: #fff;
  font-size: clamp(12px, 1.5vw, 14px);
  padding: 6px 20px;
  border-radius: 40px;
  width: fit-content;
  margin: 0 auto 10px auto;
  display: flex;
  align-items: center;

  & svg {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }
`;

export const LoginContainer = styled.div`
  width: 100%;
  padding: 16px;

  @media ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    padding: 20px;
  }
`;

export const LoginButton = styled(AnchorButton)`
  width: 100%;
  background-color: ${({ theme }) => theme.customized.colors.buttonsLinks};
  color: ${({ theme }) => theme.colors.white};
  padding: 0;
  border-radius: 0;
  text-align: center;
  font-size: 24px;
  line-height: 1.2;
  position: relative;
  overflow: hidden;

  z-index: 1;

  &::before {
    content: '';
    height: 400px;
    width: 400px;
    left: -20px;
    top: 40px;
    pointer-events: none;
    position: absolute;
    z-index: -1;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
  }

  @media (orientation: portrait) {
    border-radius: 24px 0 0 24px;
    max-width: 300px;

    &::before {
      left: -50px;
      top: 40px;
    }
  }

  &:hover {
    background-image: none;
  }

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth} {
    font-size: 20px;
  }

  @media ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    font-size: 20px;
  }
`;

export const LoginText = styled.p`
  text-transform: none;
`;
